/* eslint-disable vue/no-use-v-if-with-v-for */ /* eslint-disable vue/no-unused-vars */
<template>
  <div class="grid">
    <div class="grid-title">
      <h4>{{ $t("MANAGE_SYNC_OTA") }}</h4>
    </div>
    <div class="grid-body p-3 border-top-unset d-flex">
      <v-progress-linear color="warning" :indeterminate="true" rounded height="3" v-if="isLoading"></v-progress-linear>
      <v-row v-if="!isLoading">
        <v-col sm="3" class="pb-0">
          <v-btn color="primary" class="w-100" outlined medium @click="addNew()">
            <v-icon color="#173d8f" small>add</v-icon>
            <label class="has-action fs-12">{{ $t("ADD_NEW_SALE_CHANNEL") }}</label>
          </v-btn>
          <v-list dense>
            <v-list-item-group mandatory v-model="selectedItem" color="primary">
              <v-list-item v-for="(item, i) in listOTAConnected" :key="i" :value="item.id">
                <v-list-item-content>
                  <v-list-item-title v-text="item.ota.otaI18n.find((x) => x.lang == defaultI18n).name">
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-icon :color="item.otaStatus ? 'primary ' : '#6d6d6d'">cloud_done</v-icon>
                </v-list-item-icon>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-col>

        <v-col v-if="!isError && listOTAConnected.length > 0" sm="9" class="pb-0" style="border-left: 1px solid #cdcdcd">
          <v-row align="center">
            <v-col sm="2">
              <label>{{ $t("HOTEL_CODE") }}</label>
            </v-col>
            <v-col sm="4">
              <div class="d-connect-detail text-dark">
                {{ conectedDetail.otaHotelCode }}
              </div>
            </v-col>
            <v-col class="text-right">
              <v-btn color="primary" small class="pr-10 pl-10" @click="$refs.disconnectOta.open()">
                <span class="fs-10">{{
                  conectedDetail.status ? $t("DISCONNECT") : $t("CONNECT")
                }}</span></v-btn>
              <v-btn color="success" small class="pr-10 pl-10 ml-2" @click="$refs.undo.open()">
                <span class="fs-10">{{ $t("UNDO")
                }}</span></v-btn>
            </v-col>
          </v-row>

          <v-row align="center" class="mt-0">
            <v-col sm="2">
              <label>{{ $t("CURRENCY_OTA") }}</label>
            </v-col>
            <v-col sm="4">
              <div class="d-connect-detail text-dark">
                {{ conectedDetail.currencyCode }}
              </div>
            </v-col>
          </v-row>

          <!-- <v-row align="center" class="mt-0">
                <v-col sm="2">
                <label>{{ $t("PRICE_ON_OTA") }}</label>
                <v-tooltip top color="rgba(0, 62, 148,1)">
                    <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        color="primary"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        class="pl-2 pr-10"
                        size="18"
                    >
                        info
                    </v-icon>
                    </template>
                    <div class="description-price">
                    <template v-if="sysLang == 'vi'">
                        <p>
                        <i
                            ><u><span>Ví dụ:</span></u></i
                        >
                        </p>
                        <p>
                        Khách sạn đang sử dụng đơn vị tiền tệ là: <span>VND</span>
                        </p>
                        <p>Phòng Deluxe có giá khai báo: <span>900.000 đ</span></p>
                        <p>Tỷ giá : <span>0.00005</span></p>
                        <p>Giá chênh lệch: <span>0.5</span></p>
                        <p>
                        Thì giá bán phòng Deluxe trên các kênh OTA sau khi đồng bộ
                        sẽ là : <span>(900.000 x 0.00005) + 0.5 = 0.545 $</span>
                        </p>
                    </template>
                    <template v-else>
                        <p>
                        <i
                            ><u><span>Example:</span></u></i
                        >
                        </p>
                        <p>The hotel is using the currency: <span>VND</span></p>
                        <p>
                        Deluxe room has a declared price: <span>900.000</span>
                        </p>
                        <p>Rate: <span>0.00005</span></p>
                        <p>Price difference: <span>0.5</span></p>
                        <p>
                        Then the price of Deluxe rooms on OTA channels after
                        synchronization will be :
                        <span>(900.000 x 0.5) + 0.5 = 50 $</span>
                        </p>
                    </template>
                    </div>
                </v-tooltip>
                </v-col>
                <v-col sm="4">
                    <div class="d-flex d-exchange-rate">
                        <div class="d-method">x</div>
                        <div>
                            <vuetify-number class="input-multiplier" :options="multiplierOption" dense outlined v-model="conectedDetail.rateIndex"/>
                        </div>
                        <div class="d-method">+</div>
                        <div class="ml-auto " style="flex-grow: 4">
                            <vuetify-number class="input-plus" :options="priceOptionsEn" dense outlined v-model="conectedDetail.rateSupplement"/>
                        </div>
                    </div>

                </v-col>
                                                                                                                                              </v-row> -->
          <v-row class="mt-0">
            <v-col sm="2">
              <label>{{ $t("ROOM_CLASS_MAPING") }}</label>
            </v-col>
            <v-col>
              <v-row class="mt-0">
                <v-col sm="4" v-for="(item, index) in conectedDetail.roomTypes" class="py-0 pb-1 d-checkbox"
                  :title="item.roomTypeI18n.find((e) => e.lang === defaultI18n).name">
                  <v-checkbox v-model="selectedRoomType" :label="item.roomTypeI18n.find((e) => e.lang === defaultI18n).name"
                    :value="item.id" class="mt-0"></v-checkbox>
                </v-col>
              </v-row>
              <small class="text-danger">{{ $t("ROOM_TYPE_MAP_UNMAP") }}</small>
            </v-col>
          </v-row>

          <div class="mapping-roomtype mt-2"
            v-if="listOTAConnected.find((x) => x.id === selectedItem).otaCode !== 'TRIP_COM'">
            <v-row class="d-header-table mb-2">
              <v-col>
                <label class="font-weight-bold fs-12 text-dark">{{
                  $t("ROOM_TYPE_ON_CMS")
                }}</label>
              </v-col>
              <v-col>
                <label class="font-weight-bold fs-12 text-dark">{{
                  $t("ROOM_TYPE_ON_SABRE")
                }}</label>
              </v-col>
            </v-row>
            <template v-for="(item, i) in conectedDetail.roomTypes.filter((e) =>
              selectedRoomType.includes(e.id)
            )">
              <v-row class="mt-0">
                <v-col class="fs-12 d-flex align-items-center pt-0">
                  {{ item.roomTypeI18n.find((e) => e.lang === defaultI18n).name }} ({{
                    $t("HOTEL_LOG_id")
                  }}: {{ item.roomTypeCode }})</v-col>
                <v-col class="pt-0">
                  <v-select v-if="listOTAConnected.find((x) => x.id === selectedItem).otaCode ===
                    'TRAVELGATEX'
                    " :items="roomRateOfOta.rooms" v-model="item.otaRoomTypeCode" item-text="otaRoomTypeCode"
                    item-value="otaRoomTypeCode" @change="changeRatePlanOta(item)" dense outlined
                    :placeholder="$t('_ROOM_SALE.ROOM_TYPE.ROOM_CODE')"></v-select>
                  <v-select v-else-if="listOTAConnected.find((x) => x.id === selectedItem).otaCode === '1i'
                    " :items="roomRateOfOta.rooms" v-model="item.otaRoomTypeCode" item-text="name"
                    item-value="otaRoomTypeCode" @change="changeRatePlanOta(item)" dense outlined
                    :placeholder="$t('_ROOM_SALE.ROOM_TYPE.ROOM_CODE')"></v-select>
                  <v-text-field v-else outlined dense v-model="item.otaRoomTypeCode"
                    :placeholder="$t('_ROOM_SALE.ROOM_TYPE.ROOM_CODE')"></v-text-field>
                  <span class="v-messages theme--light error--text" v-if="findDuplicates(
                    conectedDetail.roomTypes.filter((e) =>
                      selectedRoomType.includes(e.id)
                    ),
                    'ROOM'
                  ).includes(item.otaRoomTypeCode)
                    ">{{ $t("ROOM_DUPLICATE") }}</span>
                </v-col>
              </v-row>
              <v-row class="mt-0" v-if="item.ratePlans.length > 0">
                <v-col class="pt-0 pl-5">
                  <label class="font-weight-bold fs-12 text-dark">{{
                    $t("ROOM_PLAN_ON_CMS")
                  }}</label>
                </v-col>
                <v-col class="pt-0 pl-5">
                  <label class="font-weight-bold fs-12 text-dark">{{
                    $t("ROOM_PLAN_ON_SABRE")
                  }}</label>
                </v-col>
              </v-row>
              <v-row v-for="(plan, i) in item.ratePlans" class="mt-0">
                <v-col class="fs-12 d-flex align-items-center pt-0 pl-5">
                  {{ plan.ratePlanI18n.find((e) => e.lang === defaultI18n).name }} ({{
                    $t("HOTEL_LOG_id")
                  }}: {{ plan.ratePlanCode }})
                </v-col>
                <v-col class="pt-0 pl-5">
                  <v-select v-if="listOTAConnected.find((x) => x.id === selectedItem).otaCode === 'TRAVELGATEX'" :items="item.otaRoomTypeCode
                      ? roomRateOfOta.rooms.find(
                        (e) => e.otaRoomTypeCode === item.otaRoomTypeCode
                      ).otaRatePlanCode
                      : []" v-model="plan.otaPlanCode" dense outlined
                    :placeholder="$t('_SERVICE_PACKAGE.SALE_PACKAGE_CODE')">
                  </v-select>
                  <v-select v-else-if="listOTAConnected.find((x) => x.id === selectedItem).otaCode === '1i'" :items="item.otaRoomTypeCode
                    ? roomRateOfOta.rooms.find(
                      (e) => e.otaRoomTypeCode === item.otaRoomTypeCode
                    ).otaRatePlanCode
                    : []" v-model="plan.otaPlanCode" item-text="name" item-value="otaRatePlanCode" dense outlined
                    :placeholder="$t('_SERVICE_PACKAGE.SALE_PACKAGE_CODE')">
                  </v-select>
                  <v-text-field v-else outlined dense v-model="plan.otaPlanCode"
                    :placeholder="$t('_SERVICE_PACKAGE.SALE_PACKAGE_CODE')"></v-text-field>
                  <span class="v-messages theme--light error--text" v-if="findDuplicates(item.ratePlans, 'PLAN').includes(plan.otaPlanCode)
                    ">{{ $t("ROOM_PLAN_DUPLICATE") }}</span>
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </template>
          </div>
          <div class="mapping-roomtype mt-2" v-else>
            <v-row class="d-header-table mb-2">
              <v-col cols="6">
                <label class="font-weight-bold fs-12 text-dark">{{
                  $t("ROOM_TYPE_ON_CMS")
                }}</label>
              </v-col>

              <v-col class="text-center">
                <label class="font-weight-bold fs-12 text-dark">{{
                  $t("STATUS_ROOM_TYPE_ON_OTA")
                }}</label>
              </v-col>
              <v-col cols="2" class="text-center">
                <label class="font-weight-bold fs-12 text-dark">{{
                  $t("ACTION")
                }}</label>
              </v-col>
            </v-row>
            <template v-for="(item, i) in conectedDetail.roomTypes.filter((e) =>
              selectedRoomType.includes(e.id)
            )">
              <v-row class="mt-0">
                <v-col class="fs-12 d-flex align-items-center pt-0 pl-5" cols="6">
                  {{ item.roomTypeI18n.find((e) => e.lang === defaultI18n).name }} ({{
                    $t("HOTEL_LOG_id")
                  }}: {{ item.roomTypeCode + (item.externalRoomCode ? ' | ' + item.externalRoomCode : '') }})</v-col>
                <v-col class="pt-0 text-center" :class="item.externalRoomCode ? 'CONNECTED' : 'NOT_CONNECTED'">
                  {{ item.externalRoomCode ? $t('CONNECTED') : $t('NOT_CONNECTED') }}
                </v-col>
                <v-col cols="2" class="pt-0">

                </v-col>

              </v-row>
              <v-row class="mt-0" v-if="item.ratePlans.length > 0">
                <v-col class="pt-0 pl-5" cols="6">
                  <label class="font-weight-bold fs-12 text-dark pl-3">{{
                    $t("ROOM_PLAN_ON_CMS")
                  }}</label>
                </v-col>
                <v-col class="pt-0 pl-5">
                </v-col>
              </v-row>
              <v-row v-for="(plan, i) in item.ratePlans" class="mt-0">
                <v-col class="fs-12 d-flex align-items-center pt-0 pl-5" cols="6">
                  <span class="pl-3">
                    {{ plan.ratePlanI18n.find((e) => e.lang === defaultI18n).name }} ({{
                      $t("HOTEL_LOG_id")
                    }}: {{ plan.ratePlanCode + (plan.externalPlanCode ? ' | ' + plan.externalPlanCode : '') }})
                  </span>
                </v-col>
                <v-col class="pt-0 text-center"
                  :class="optionStatus.find(e => e.value === plan.roomRates[0].connectionStatus).text">
                  {{ $t(optionStatus.find(e => e.value === plan.roomRates[0].connectionStatus).text) }}
                </v-col>
                <v-col cols="2" class="pt-0 d-flex justify-content-center">
                  <v-switch class="mt-0 pt-0" v-model="plan.roomRates[0].status"
                    :disabled="plan.roomRates[0].connectionStatus === 2"
                    :color="optionStatus.find(e => e.value === plan.roomRates[0].connectionStatus).color"></v-switch>
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </template>
          </div>

          <div class="text-right">
            <v-btn color="primary" class="pr-10 pl-10" @click="checkBeforeUpdate()" :disabled="isLoadingPopup">
              {{ $t(!checkReSync ? "SAVE" : "RE_SYNC_CONNECT") }}</v-btn>
          </div>
        </v-col>
        <v-col v-if="listOTAConnected.length === 0" sm="9" class="pb-0" style="border-left: 1px solid #cdcdcd">
          <v-row>
            <v-col sm="12" class="text-center">
              <v-icon style="height: 100%; font-size: 150px" color="#fed12f">warning</v-icon>
            </v-col>
            <v-col sm="12">
              <p class="text-center">
                {{ $t("ACCOUNT_IS_NOT_CONNECTED_TO_GDS") }}
                <br />
                {{ $t("CANNOT_GET_INFO_FROM_OTA_2") }}
              </p>
              <div class="text-center">
                <i class="fs-10">{{ $t("TEXT_GDS_INFOMATION") }}</i>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>

    <v-dialog v-model="popupAddNew" width="500">
      <v-card class="popup-add-new-channel">
        <template v-if="!isStep2">
          <v-autocomplete item-text="text" item-value="value" :items="listSelectOTA" :label="$t('SELECT_SALE_CHANNEL')"
            dense outlined v-model="selectedOTA">
            <template slot="no-data">
              <div class="no-data">{{ $t("NO_DATA") }}</div>
            </template>
          </v-autocomplete>

          <div class="instruction" v-html="descriptionOTA"></div>
          <div class="instruction text-danger fs-10" v-if="errNullSelect">
            {{ errNullSelect }}
          </div>

          <v-divider></v-divider>

          <div class="text-center">
            <v-btn color="primary" @click="step2()" :disabled="isLoadingPopup">
              {{ $t("CONNECT") }}
            </v-btn>
          </div>
        </template>
        <template v-if="isStep2">
          <v-form ref="formValidate" lazy-validation>
            <loading :active.sync="isLoadingPopup" :is-full-page="false"></loading>
            <v-row>
              <v-col class="pt-0 pb-0">
                <label>{{ $t("HOTEL_CODE") }}</label>
                <v-text-field dense outlined v-model="otaHotelCode" :rules="[rules.required]"
                  :placeholder="$t('HOTEL_CODE')"></v-text-field>
              </v-col>
            </v-row>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="connect()" :disabled="isLoadingPopup">
                {{ $t("CONNECT") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </template>
      </v-card>
    </v-dialog>
    <confirm-dialog @deleteItem="disconnect" :maxWidth="325" ref="disconnectOta">
      <span slot="title">{{
        conectedDetail.status
        ? $t("CONFIRM_DISCONNECT_OTA")
        : $t("CONFIRM_CONNECT_OTA")
      }}?</span>
    </confirm-dialog>
    <confirm-dialog @deleteItem="undo" :maxWidth="559" ref="undo">
      <span slot="title">{{ $t("CONFIRM_UNDO")
      }}?</span>
    </confirm-dialog>
    <confirm-dialog @deleteItem="update" :maxWidth="559" ref="confirmSave">
      <span slot="title">{{ $t("CONFIRM_SAVE") }}</span>
    </confirm-dialog>
  </div>
</template>

<style lang="scss">
.description-price {
  padding: 10px;

  p {
    margin-bottom: 2px;

    span {
      font-weight: bold;
    }
  }
}

.main-table {
  width: 100%;
}

.main-table td>span {
  font-size: 14px !important;
}

.d-checkbox {
  .v-input__slot {
    align-items: flex-start !important;

    label {
      overflow: hidden;
      display: -webkit-box !important;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      /* autoprefixer: off */
    }
  }
}
</style>

<script>
import { REGEX_NUMBER } from "@/_helpers/constant.js";
import { _alert } from "@/_helpers/function.js";
import { syncota } from "@/_services/SyncOTA/syncota.js";
import moment from "moment";
import ConfirmDialog from "@/components/Utils/ConfirmDialog.vue";

export default {
  components: {
    "confirm-dialog": ConfirmDialog,
  },
  data() {
    return {
      rules: {
        required: (value) =>
          (!!value && value.length > 0) || this.$t("_REGISTER.REQUIRED_FIELD"),
      },
      sysLang: this.$i18n.locale,
      popupAddNew: false,
      isLoading: false,
      dataAllOTA: [],
      listSelectOTA: [],
      listOTAConnected: [],
      selectedItem: 0,
      descriptionOTA: "",
      selectedOTA: "",
      isStep2: false,
      idOTA: "",
      username: "",
      password: "",
      allRoomType: "",
      listSelectRoomType: [],
      allRatePlan: "",
      listSelectOccupancy: [],
      listSelectRatePlan: [],
      conectedDetail: "",
      conectedDetailBefore: "",
      isLoadingPopup: false,
      form: {
        // otaUsername: '',
        // otaHotelCode: '',
        // otaPassword: '',
      },
      isError: false,
      connectionType: null,
      otaCode: null,
      currentSubView: null,
      // Check điều kiện nếu là BE thì ko hiển thị thông tin mapping phòng
      isBeConnected: false,
      RoomRateByOta: [],
      isGoogleHotel: false,
      errNullSelect: null,
      otaExternalRoomTypeIds: [],
      otaHotelCode: null,
      multiplierOption: {
        prefix: "",
        locale: "vi",
        length: 3,
        precision: 2,
      },
      selectedRoomType: [],
      roomRateOfOta: [],
      selectedRoomTypeBefore: [],
      optionStatus: [
        {
          value: 0,
          color: '#ccc',
          text: 'NOT_CONNECTED'
        },
        {
          value: 1,
          color: 'primary',
          text: 'CONNECTED'
        },
        {
          value: 2,
          color: '#ccc',
          text: 'MISSING_ROOM_AND_PRICE'
        },
        {
          value: 3,
          color: 'orange',
          text: 'CONNECTING'
        },
        {
          value: 4,
          color: 'error',
          text: 'CONNECTION_FAILED'
        }
      ],
    };
  },
  computed: {
    REGEX_NUMBER() {
      return REGEX_NUMBER;
    },
    roomTypeIds() {
      const arr = this.conectedDetail.otaRoomType.map((x) => {
        if (this.otaExternalRoomTypeIds.includes(x.otaRoomTypeCode)) {
          return x.roomType.id;
        } else return null;
      });
      var newArr = [];
      newArr = arr.filter(function (item) {
        return newArr.includes(item) ? "" : newArr.push(item);
      });
      return newArr.filter((e) => e !== null);
    },
    RatePlanIds() {
      const arr = this.conectedDetail.otaRatePlan.map((x) => {
        return x.ratePlan.id;
      });
      return arr.filter((e) => e !== null);
    },
    occupancyRoomIds() {
      const arr = this.conectedDetail.otaOccupancies.map((x) => {
        return x.roomType.id;
      });
      return arr.filter((e) => e !== null);
    },
    checkReSync() {
      return !this.deepObjectEqual(this.selectedRoomTypeBefore, this.selectedRoomType) || !this.deepObjectEqual(this.conectedDetailBefore, this.conectedDetail) ? false : true
    }
  },
  created() {
    this.initialize();
  },
  watch: {
    selectedOTA(value) {
      if (value) {
        this.errNullSelect = null;
      }
      // this.descriptionOTA = this.dataAllOTA.find((x) => x.id == value).instructionVi;
      const foundOTA = this.dataAllOTA.find((x) => x.id == value);
      if (foundOTA) {
        const otaI18n = foundOTA.otaI18n.find((y) => y.lang == this.defaultI18n);
        this.descriptionOTA = otaI18n ? otaI18n.description : "";
      } else {
        this.descriptionOTA = "";
      }
      // // console.log( JSON.parse( this.dataAllOTA.find( x => x.id == value ).credentialsVi ) );
      this.connectionType = this.dataAllOTA.find((x) => x.id == value).connectionType;

      this.otaCode = this.dataAllOTA.find((x) => x.id == value).otaCode;
      this.form = {};
      this.form = Object.assign(
        this.form,
        JSON.parse(this.dataAllOTA.find((x) => x.id == value).credentialsVi)
      );
    },
    selectedItem(value) {
      // Lấy thông tin chi tiết đồng bộ của 1 kênh
      if (this.listOTAConnected.find((x) => x.id === value).otaCode === "TRAVELGATEX") {
        this.getRoomRateOta(
          this.listOTAConnected.find((x) => x.id === value).otaHotelCode
        );
      }
      if (this.listOTAConnected.find((x) => x.id === value).otaCode === "1i") {
        this.getRoomRateOta1i(
          this.listOTAConnected.find((x) => x.id === value).otaHotelCode
        );
      }
      this.isLoading = true;
      this.isError = false;
      this.conectedDetail = "";
      this.conectedDetailBefore = "";
      if (this.listOTAConnected.find((x) => x.id === value).otaCode !==
        'TRIP_COM') {
        syncota
          .detailSyncOTAGds1x(value)
          .then((res) => {
            if (res.responseCode === 0) {
              this.conectedDetail = res.data;
              this.conectedDetailBefore = JSON.parse(JSON.stringify(res.data));
              if (res.data.otaExternalRoomType) {
                this.otaExternalRoomTypeIds = this.conectedDetail.otaExternalRoomType.map(
                  (x) => {
                    return x.id;
                  }
                );
              }
              this.selectedRoomType = [];
              this.selectedRoomTypeBefore = [];
              this.conectedDetail.roomTypes.forEach((x) => {
                if (x.otaRoomTypeCode) {
                  this.selectedRoomType.push(x.id);
                  this.selectedRoomTypeBefore.push(x.id);
                }
              });
            } else {
              if (res.data == "OTA_CONNECTION_ERROR") {
                this.isError = true;
              } else {
                _alert(res, this.$t(res.data), false);
              }
            }
          })
          .finally(() => (this.isLoading = false));
      } else {
        syncota
          .detailSyncOTAGdsCTrip(value)
          .then((res) => {
            if (res.responseCode === 0) {
              this.conectedDetail = res.data;
              this.conectedDetailBefore = JSON.parse(JSON.stringify(res.data));
              if (res.data.otaExternalRoomType) {
                this.otaExternalRoomTypeIds = this.conectedDetail.otaExternalRoomType.map(
                  (x) => {
                    return x.id;
                  }
                );
              }
              this.selectedRoomType = [];
              this.selectedRoomTypeBefore = [];
              this.conectedDetail.roomTypes.forEach((x) => {
                if (x.externalRoomCode) {
                  this.selectedRoomType.push(x.id);
                  this.selectedRoomTypeBefore.push(x.id);
                }
              });
            } else {
              if (res.data == "OTA_CONNECTION_ERROR") {
                this.isError = true;
              } else {
                _alert(res, this.$t(res.data), false);
              }
            }
          })
          .finally(() => (this.isLoading = false));
      }
    },
    // conectedDetail: {
    // handler(val) {
    //     this.selectedRoomType = []
    //     val.roomTypes.forEach(x => {
    //         if (x.otaRoomTypeCode) {
    //              this.selectedRoomType.push(x.id)
    //         }
    //     })
    // }, deep: true
    // }
  },
  methods: {
    undo() {
      location.reload();
    },
    getRoomRateOta(value) {
      syncota.getRoomRateOta1x(value).then((res) => {
        if (res.responseCode === 0) {
          this.roomRateOfOta = res.data;
        }
      });
    },
    getRoomRateOta1i(value) {
      syncota.getRoomRateOta1i(value).then((res) => {
        if (res.responseCode === 0) {
          this.roomRateOfOta = res.data;
          var arrPlan = [
            {
              otaRatePlanCode: null,
              name: this.$t('SELECT_SALE_PACKAGE')
            }
          ]
          this.roomRateOfOta.rooms.forEach(e => {
            e.name = e.i18ns.find((i) => i.lang === this.defaultI18n).name + ` (${this.$t("HOTEL_LOG_id")}: ${e.otaRoomTypeCode})`
            e.otaRatePlanCode.forEach(p => {
              p.name = p.i18ns.find((i) => i.lang === this.defaultI18n).name + ` (${this.$t("HOTEL_LOG_id")}: ${p.otaRatePlanCode})`
            })
            e.otaRatePlanCode = arrPlan.concat(e.otaRatePlanCode)
          })
        }
      });
    },
    changeRatePlanOta(room) {
      room.ratePlans.forEach((e) => {
        e.otaPlanCode = null;
      });
    },
    findDuplicates(arr, type) {
      let array = [];
      if (type === "ROOM") {
        array = arr.map((item) => item.otaRoomTypeCode).filter((e) => e);
      } else {
        array = arr.map((item) => item.otaPlanCode).filter((e) => e);
      }
      return array.filter((item, index) => array.indexOf(item) != index);
    },
    async initialize() {
      this.isLoading = true;
      let body = {
        keyword: "",
        status: 1,
      };
      await syncota.getAllOTANotConnectGds1x(body).then((res) => {
        if (res.responseCode === 0) {
          this.dataAllOTA = res.data;
          this.listSelectOTA = res.data.map((x) => {
            return {
              value: x.id,
              text: x.otaI18n.find((y) => y.lang == this.defaultI18n).name,
            };
          });
          this.listSelectOTA = this.listSelectOTA.filter((x) => x.value);

          this.listSelectOTA.sort(function (a, b) {
            var nameA = a.text.toLowerCase(),
              nameB = b.text.toLowerCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
          });
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });

      await syncota.getConnectedOTAGds1x(body).then((res) => {
        if (res.responseCode === 0) {
          this.listOTAConnected = res.data;
          if (this.listOTAConnected.length > 0) {
            this.selectedItem = this.listOTAConnected[0].id;
          } else {
            this.isLoading = false;
          }
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });
    },
    addNew() {
      this.popupAddNew = true;
    },
    checkBeforeUpdate() {
      if (!this.deepObjectEqual(this.selectedRoomTypeBefore, this.selectedRoomType) || !this.deepObjectEqual(this.conectedDetailBefore, this.conectedDetail)) {
        this.$refs.confirmSave.open()
      } else {
        this.update();
      }
    },
    update() {
      let isUpdate = true;
      if (
        this.findDuplicates(
          this.conectedDetail.roomTypes.filter((e) =>
            this.selectedRoomType.includes(e.id)
          ),
          "ROOM"
        ).length > 0
      ) {
        isUpdate = false;
      }
      this.conectedDetail.roomTypes.forEach((e) => {
        if (!this.selectedRoomType.includes(e.id) && this.listOTAConnected.find((x) => x.id === this.selectedItem).otaCode !== 'TRIP_COM') {
          e.otaRoomTypeCode = null;
        } else if (!this.selectedRoomType.includes(e.id) && this.listOTAConnected.find((x) => x.id === this.selectedItem).otaCode === 'TRIP_COM') {
          e.externalRoomCode = null;
          e.ratePlans.forEach(pl => pl.roomRates[0].status = false);
        } else if (this.selectedRoomType.includes(e.id) && this.listOTAConnected.find((x) => x.id === this.selectedItem).otaCode === 'TRIP_COM') {
          e.externalRoomCode = 'MAP';
        }
        if (this.findDuplicates(e.ratePlans, "PLAN").length > 0) {
          isUpdate = false;
        }
      });
      let connectSaving = this.conectedDetail.roomTypes;
      if (!isUpdate) {
        _alert(null, this.$t("DATA_INPUT_INVALID"));
        return;
      }
      this.isLoading = true;
      if (this.listOTAConnected.find((x) => x.id === this.selectedItem).otaCode !== 'TRIP_COM') {
        syncota
          .updateDetailSyncOTAGds1x(
            connectSaving,
            this.listOTAConnected.find((e) => e.id === this.selectedItem).ota.id
          )
          .then((res) => {
            _alert(res, this.$t(res.data), true);
          })
          .finally(() => (this.isLoading = false));
      } else {
        syncota
          .updateDetailSyncOTAGdsCtrip(
            connectSaving,
            this.listOTAConnected.find((e) => e.id === this.selectedItem).ota.id
          )
          .then((res) => {
            _alert(res, this.$t(res.data), true);
          })
          .finally(() => (this.isLoading = false));
      }

    },
    step2() {
      if (this.selectedOTA) {
        if (this.connectionType == 3) {
          this.connect();
          // Nếu chọn thêm mới BE
        } else if (
          this.connectionType == 1 &&
          (this.otaCode == "EZ_BE" || this.otaCode == "EZ_GOOGLE_HOTEL")
        ) {
          this.connect();
          // Đóng popup thêm mới
          this.popupAddNew = false;
        } else {
          this.isStep2 = true;
        }
      } else {
        this.errNullSelect = this.$t("CHANNEL_EMPTY");
      }
    },
    connect() {
      if (this.isStep2) {
        let isValidFrom = this.$refs.formValidate.validate();
        if (!isValidFrom) {
          _alert(null, this.$t("_VALIDATE.REQUIRED"));
          return;
        }
      }

      // if (!this.otaHotelCode)
      let body = {
        ota: {
          id: this.selectedOTA,
        },
        otaHotelCode: this.otaHotelCode,
      };
      this.isLoadingPopup = true;
      syncota
        .createConnectOTAGds1x(body)
        .then((res) => {
          if (res.responseCode == 0) {
            if (this.connectionType == 3 && this.otaCode !== 'TRIP_COM') {
              window.location.replace(res.data);
            } else {
              _alert(res, this.$t(res.data), true);
            }
          } else {
            _alert(res, this.$t(res.data), true);
            location.reload();
          }
        })
        .finally(() => (this.isLoadingPopup = false));
    },
    disconnect() {
      this.isLoadingPopup = true;
      syncota
        .disconnectOTAGds1x(
          this.listOTAConnected.find((e) => e.id === this.selectedItem).ota.id
        )
        .then((res) => {
          _alert(res, this.$t(res.data), true);
          location.reload();
        })
        .finally(() => (this.isLoadingPopup = false));
    },
    viewDetail(i) {
      this.currentSubView = i;
    },
    _moment: moment,
  },
};
</script>
